import { useProcessAsync } from '@gogame/hooks-ts';

import { loadAffiliates } from 'scenes/Users/AdminUsers/sources/fields';

import {
  CATEGORY_CUSTOMER_COMPANIES,
  CATEGORY_AFFILIATES,
} from 'scenes/Users/components/UserPermissions/constants';

import { PERMISSIONS } from 'scenes/Users/AdminUsers/components/UserForm/constants';

const usePermissionChange = ({ values, setFieldValue }) => {
  const [isLoading, processAsync] = useProcessAsync();

  const processLoadAffiliates = async (params) =>
    processAsync(loadAffiliates(params));

  return {
    isLoading,
    onCustomerCompaniesChange: async (_, customerCompanies) => {
      if (!customerCompanies) {
        return;
      }

      const { [CATEGORY_CUSTOMER_COMPANIES]: valuesCustomerCompanies = [] } =
        values[PERMISSIONS] || {};

      const customerCompaniesParams = customerCompanies.sort();

      if (
        customerCompaniesParams.toString() !==
        valuesCustomerCompanies.sort().toString()
      ) {
        const affiliates = customerCompaniesParams.length
          ? await processLoadAffiliates({
              [CATEGORY_CUSTOMER_COMPANIES]: customerCompaniesParams,
            })
          : [];

        setFieldValue(
          `${PERMISSIONS}.${CATEGORY_AFFILIATES}`,
          affiliates.map(({ id }) => id)
        );
      }
    },
  };
};

export default usePermissionChange;
